export default __webpack_public_path__ + "static/media/details-off.73bf8035.svg";